import { styled } from "baseui";

export const StyledSingleLineText = styled<"div", {}>("div", ({ $theme }) => ({
  //width: "200px",
  whiteSpace: "nowrap" /* Prevents text from wrapping */,
  overflow: "hidden" /* Hides the overflow text */,
  textOverflow: "ellipsis" /* Adds an ellipsis (...) to indicate overflow */,
  ...$theme.typography.ParagraphSmall,
  maxLines: 3,
  color: $theme.colors.contentTertiary,
}));

export const StyledToolbar = styled<"div", {}>("div", ({ $theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "baseline",
}));

export const StyledRoot = styled<"div", {}>("div", ({ $theme }) => ({
  width: "100%",
  position: "relative",
}));

export const StyledUsagePerBuildingRoot = styled<"div", {}>("div", ({ $theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: $theme.sizing.scale1200,
}));
